import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { Flex, Radio, TextV2 } from '@withjoy/joykit';

import { useTranslation } from '@shared/core';
import { useCarSortOptions } from '../../hooks/useCarSortOptions';
import type { CarRatesSortDto } from '../../CarRentalConsole.types';

type MobileSortOptionsProps = Readonly<{
  sortOption: CarRatesSortDto;
  onSortChange: (sort: CarRatesSortDto) => void;
}>;

export const MobileSortOptions = ({ sortOption, onSortChange }: MobileSortOptionsProps) => {
  const { tq } = useTranslation('carRentalConsole');
  const sortOptions = useCarSortOptions();

  return (
    <Flex
      gap={4}
      flexDirection="column"
    >
      <TextV2 typographyVariant="hed4">{tq`Sort by`}</TextV2>
      <Flex
        flexDirection="column"
        gap={3}
      >
        {sortOptions.map(option => (
          <Radio
            name="carSortBy"
            key={option.value}
            value={option.value}
            label={option.label}
            id={`car-sort-${option.value}`}
            style={{ fontSize: pxToRem(16) }}
            checked={sortOption === option.value}
            onChange={() => onSortChange(option.value)}
          />
        ))}
      </Flex>
    </Flex>
  );
};
